import { Box, SimpleGrid, Slider, Text, chakra } from '@chakra-ui/react'
import { CONFIDENCE_STEPS, confidenceStepFor } from '@src/components/sco/Admin/AiCrm/data/types'
import React from 'react'

/**
 * Jev auto-send bars: 95, 85, 75, 65, and 50. A stored bar the steps do not hit
 * exactly shows on its nearest step. The rail runs from the middle of the first
 * label to the middle of the last, so each stop sits over its words.
 */
export function ConfidenceSteps(props: {
  /** The slider's accessible name. */
  ariaLabel?: string
  disabled?: boolean
  onChange: (bar: number) => void
  value: number | null
}) {
  const current = confidenceStepFor(props.value)
  const index = current ? CONFIDENCE_STEPS.findIndex(step => step.key === current.key) : 0
  return (
    <Box>
      <Box mx={`${50 / CONFIDENCE_STEPS.length}%`} pt={2}>
        <Slider.Root
          aria-label={[props.ariaLabel || 'Jev confidence to auto-send']}
          colorPalette={'yellow'}
          disabled={props.disabled}
          getAriaValueText={details => {
            const step = CONFIDENCE_STEPS[details.value]
            return step ? `${step.label}. ${step.hint}` : String(details.value)
          }}
          max={CONFIDENCE_STEPS.length - 1}
          min={0}
          size={'md'}
          step={1}
          thumbAlignment={'center'}
          value={[index]}
          onValueChange={event => props.onChange(CONFIDENCE_STEPS[event.value[0]].bar)}
        >
          <Slider.Control>
            <Slider.Track>
              <Slider.Range />
            </Slider.Track>
            <Slider.Thumbs />
          </Slider.Control>
        </Slider.Root>
      </Box>
      <SimpleGrid columns={CONFIDENCE_STEPS.length} gap={2} mt={3}>
        {CONFIDENCE_STEPS.map((step, at) => {
          const on = at === index
          return (
            <chakra.button
              key={step.key}
              aria-pressed={on}
              bg={on ? 'yellow.subtle' : 'transparent'}
              borderColor={on ? 'yellow.border' : 'transparent'}
              borderRadius={'lg'}
              borderWidth={'1px'}
              cursor={props.disabled ? 'not-allowed' : 'pointer'}
              disabled={props.disabled}
              px={2}
              py={1.5}
              textAlign={'center'}
              type={'button'}
              onClick={() => props.onChange(step.bar)}
            >
              <Text color={on ? 'fg' : 'fg.muted'} fontSize={'xs'} fontWeight={'bold'}>
                {step.label}
              </Text>
              <Text color={on ? 'fg.muted' : 'fg.subtle'} fontSize={'2xs'} lineHeight={'1.35'} mt={0.5}>
                {step.hint}
              </Text>
            </chakra.button>
          )
        })}
      </SimpleGrid>
      <Box display={'flex'} justifyContent={'space-between'} mt={2}>
        <Text color={'fg.subtle'} fontSize={'2xs'}>
          Higher Jev score
        </Text>
        <Text color={'fg.subtle'} fontSize={'2xs'}>
          Lower Jev score
        </Text>
      </Box>
    </Box>
  )
}
